
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/electric-signature-legality",
      function () {
        return require("private-next-pages/signature/electric-signature-legality/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/electric-signature-legality"])
      });
    }
  